import { QimaOptionalType } from '@qima/ngx-qima';

export interface UserRole {
  [key: string]: string[];
}

export interface UserData {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  roles?: UserRole | string[]; // Support both formats
  isActive?: boolean;
  lastLogin?: QimaOptionalType<string>;
}

export class User {
  public id: string;
  public username: string;
  public email: string;
  public firstName: string;
  public lastName: string;
  public roles: string[]; // Array of role strings for compatibility with auditor-app
  public isActive: boolean;
  public lastLogin?: QimaOptionalType<string>;

  constructor(data: UserData) {
    this.id = data.id;
    this.username = data.username;
    this.email = data.email;
    this.firstName = data.firstName;
    this.lastName = data.lastName;

    const rolesObj = data.roles as Record<string, string[]>;
    if (rolesObj.WQS !== null && rolesObj.WQS !== undefined) {
      this.roles = rolesObj.WQS;
    } else {
      this.roles = [];
    }

    this.isActive = data.isActive ?? true;
    this.lastLogin = data.lastLogin;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  get displayName(): string {
    return this.fullName || this.username;
  }

  hasRole(roleName: string): boolean {
    return this.roles.includes(roleName);
  }

  hasAnyRole(roleNames: string[]): boolean {
    return roleNames.some(roleName => this.roles.includes(roleName));
  }

  toJSON() {
    return {
      id: this.id,
      username: this.username,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      roles: this.roles,
      isActive: this.isActive,
      lastLogin: this.lastLogin,
    };
  }
}
